import MediumHeader from "../UI/textFields/MediumHeader";
import StandardButton from "../UI/buttons/StandardButton";
import labels from "../../utils/labels";
import { Spinner } from "../UI/Spinner";

const AlreadyExistsWarning = ({
  onGoToExistingClick,
  onOverwriteExistingClick,
  isStarting,
}: {
  onGoToExistingClick: () => void;
  onOverwriteExistingClick: () => void;
  isStarting: boolean;
}) => {
  return (
    <div className="AlreadyExistsWarning fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 h-[190px] w-[620px]">
        <MediumHeader classes={"pb-2"}>
          {labels.nexusLandingDataAlreadyExistsWarningHeader}
        </MediumHeader>
        <p className={"bodyTwo pb-2"}>
          {labels.nexusLandingDataAlreadyExistsWarningBody}
        </p>
        <div className={"flex flex-row justify-end"}>
          <StandardButton
            variant={"SECONDARY"}
            classes={"mr-6"}
            onClick={onGoToExistingClick}
            disable={isStarting}
            ariaLabel={labels.nexusLandingPageGoToExistingButton}
          >
            {labels.nexusLandingPageGoToExistingButton}
          </StandardButton>
          <StandardButton
            variant={"PRIMARY"}
            onClick={onOverwriteExistingClick}
            disable={isStarting}
            ariaLabel={labels.nexusLandingPageOverwriteData}
          >
            {isStarting ? (
              <span className="flex items-center gap-2">
                <Spinner width={20} height={20} />
                {labels.nexusLandingPageStartingImport}
              </span>
            ) : (
              labels.nexusLandingPageOverwriteData
            )}
          </StandardButton>
        </div>
      </div>
    </div>
  );
};

export default AlreadyExistsWarning;
